<template>
  <MainLayout>
    <b-row id="validationRulesContainer">
      <b-col
        class="shadow-sm"
        style
      >
        <b-card-body>
          <h4
            class="card-title font-weight-bold"
            style="margin-bottom: 40px"
          >
            Vertrags-Validierungsregeln verwalten
          </h4>
          <u-error-handling
            v-if="errorObject"
            :error-object="errorObject"
          />
          <u-loader v-if="isloading" />
          <table
            v-else
            class="w-100 validationConfigurationTable ml-2 mt-4"
          >
            <thead>
              <tr>
                <th>Bereich</th>
                <th>Eigenschaft</th>
                <th>Einstellung</th>
                <th>Fehlermeldung / Hinweis / Warnung</th>
                <th>Aktionen</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(validationConfiguration, index) in allValidationData"
                :key="index"
              >
                <td>
                  <div
                    v-if="
                      index == 0 ||
                        allValidationData[index - 1].section !=
                        validationConfiguration.section
                    "
                  >
                    <b>{{ validationConfiguration.section }}</b>
                  </div>
                </td>
                <td>
                  <div>
                    {{
                      validationConfiguration
                        .customContractValidationContents[0].propertyDisplayName
                    }}
                  </div>
                </td>
                <td>
                  <div v-if="currentEditRow != index">
                    {{
                      settingsMapping.filter((mapping) => {
                        return (
                          validationConfiguration.validationType ==
                          mapping.value
                        );
                      })[0].name
                    }}
                  </div>
                  <div v-else>
                    <v-radio-group
                      v-model="validationConfiguration.validationType"
                      class="validationRadio"
                    >
                      <v-radio
                        v-for="(map, mapIndex) in settingsMapping"
                        :key="mapIndex"
                        :label="map.name"
                        :value="map.value"
                        color="black"
                      />
                    </v-radio-group>
                  </div>
                </td>
                <td>
                  <div v-if="currentEditRow != index">
                    {{
                      validationConfiguration.validationType != 1
                        ? validationConfiguration
                          .customContractValidationContents[0].value
                        : ""
                    }}
                  </div>
                  <div v-else-if="validationConfiguration.validationType != 1">
                    <v-text-field
                      v-model="
                        validationConfiguration
                          .customContractValidationContents[0].value
                      "
                      type="text"
                      class="mr-4 normalFontSize"
                      auto-grow
                      multi-line
                      rows="1"
                      :label="
                        validationConfiguration.validationType == 4
                          ? 'Warnung (wird nur angezeigt wenn die Eigenschaft leer ist)'
                          : validationConfiguration.validationType == 2
                            ? 'Hinweis (wird immer angezeigt)'
                            : 'Fehlermeldung (wird nur angezeigt wenn die Eigenschaft leer ist)'
                      "
                    />
                  </div>
                </td>
                <td v-if="currentEditRow != index">
                  <button
                    v-if="$IsUserInRole('VertragsmanagementVerwaltung')"
                    v-b-tooltip.hover
                    type="button"
                    placement="bottom"
                    title="Regel bearbeiten"
                    class="btn btn-primary smallActionButton ml-2"
                    @click="
                      resetValidationConfiguration();
                      currentEditRow = index;
                    "
                  >
                    <i class="fas fa-edit" />
                  </button>
                </td>
                <td v-else>
                  <button
                    v-b-tooltip.hover
                    type="button"
                    placement="bottom"
                    title="Speichern"
                    class="btn btn-success smallActionButton ml-2"
                    @click="saveValidationRule()"
                  >
                    <i class="fas fa-check" />
                  </button>

                  <button
                    v-b-tooltip.hover
                    type="button"
                    placement="bottom"
                    title="Abbrechen"
                    class="btn btn-danger smallActionButton ml-2"
                    @click="
                      resetValidationConfiguration();
                      currentEditRow = -1;
                    "
                  >
                    <i class="fas fa-times" />
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </b-card-body>
      </b-col>
    </b-row>
  </MainLayout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout.vue";
import {
  GetAllValidationRules,
  SaveValidationRule,
} from "@/services/validation.rules.service.js";
import { setTimeout } from "timers";

export default {
  components: {
    MainLayout,
  },
  data() {
    return {
      currentEditRow: -1,
      isloading: false,
      errorObject: null,
      allValidationData: [],
      allOriginalValidationData: [],
      previousScrollPosition: 0,
      settingsMapping: [
        { value: 1, name: "keine" },
        { value: 2, name: "Hinweis" },
        { value: 4, name: "Warnung" },
        { value: 3, name: "Erforderlich" },
      ],
    };
  },
  created() {
    this.loadAllValidationData();
  },
  methods: {
    resetValidationConfiguration() {
      this.allValidationData = JSON.parse(
        JSON.stringify(this.allOriginalValidationData),
      );
    },
    saveValidationRule() {
      this.errorObject = null;

      var ruleToSave = this.allValidationData[this.currentEditRow];

      SaveValidationRule(
        ruleToSave.id,
        ruleToSave,
        () => {
          this.loadAllValidationData();
        },
        (error) => {
          this.errorObject = error;
        },
      );
    },
    loadAllValidationData() {
      this.errorObject = null;
      this.isloading = true;
      this.currentEditRow = -1;
      this.previousScrollPosition = window.scrollY;

      GetAllValidationRules(
        (response) => {
          this.$validationRules = JSON.parse(JSON.stringify(response));
          this.allValidationData = JSON.parse(JSON.stringify(response));
          this.allOriginalValidationData = JSON.parse(JSON.stringify(response));
          this.isloading = false;
          setTimeout(() => {
            window.scrollTo(0, this.previousScrollPosition);
          }, 1);
        },
        (error) => {
          this.errorObject = error;
          this.isloading = false;
        },
      );
    },
  },
};
</script>

<style>
#validationRulesContainer .v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
  margin-bottom: 0px;
  padding-bottom: 0px;
}

#validationRulesContainer .validationRadio .theme--light.v-label {
  font-size: 14px;
  color: black;
  margin-bottom: 0px;
}

#validationRulesContainer .v-icon {
  font-size: 20;
}
#validationRulesContainer
  .v-input--selection-controls:not(.v-input--hide-details)
  .v-input__slot {
  margin-bottom: 0px;
}
#validationRulesContainer .theme--light.v-messages {
  display: none;
}
#validationRulesContainer .v-textarea--no-resize textarea {
  font-size: 14px;
}
</style>

<style scoped>
.smallActionButton {
  width: 25px;
  height: 25px;
  font-size: 17px;
  padding: 0px;
}

.validationConfigurationTable {
  font-size: small;
  table-layout: fixed;
}

.validationConfigurationTable tbody tr {
  border-bottom: 1px solid #ddd;
}
.validationConfigurationTable th {
  padding-right: 30px;
  padding-bottom: 10px;
  border-bottom: 1px solid black;
}
.validationConfigurationTable thead th:nth-child(1) {
  width: 12%;
}
.validationConfigurationTable thead th:nth-child(2) {
  width: 18%;
}
.validationConfigurationTable thead th:nth-child(3) {
  width: 12%;
}
.validationConfigurationTable thead th:nth-child(4) {
  width: 50%;
}
.validationConfigurationTable thead th:nth-child(5) {
  width: 8%;
}
.validationConfigurationTable tr td:first-child {
  border-bottom: 2px solid white;
}
.validationConfigurationTable tr td {
  padding-bottom: 10px;
  padding-top: 10px;
  vertical-align: top;
}
.validationConfigurationTable tr:nth-child(2n) td {
  padding-top: 10px;
}
</style>
